export const translate = (vocabulary, value) => {
  for (let key in vocabulary) {
    if (vocabulary.hasOwnProperty(key)){
      // с бэка периодически прилетает строка, а не цифра, поэтому сравнение не строгое
      if (value == key) {
        return vocabulary[key];
      }
    }
  }
  return value;
};

export const statusCodesVocabulary = {
  "4500":"Передано",
  "4600":"В роботі",
  "4800":"Відпрацьовано банком",
}

export const notaryRequestTypeVocabulary = {
  1:"Запит по померлій особі",
  2:"Запит по безвісно відсутній особі",
  3:"Запит по особі зниклій безвісти за особливих обставин",
}